define.alias("ember-composable-helpers/helpers/entries", "settings/helpers/entries");